export class AppEndpoints {
	private static readonly self = 'api/';
	private static readonly onboardingApiPrefix = 'onboardingApi/';

	public static getLogin: string = AppEndpoints.self + "login/getLogin";
	public static signIn: string = 'account/login';
	public static userStatus: string = 'account/userstatus';
	public static delegateRequest: string = 'api/login/delegationrequest';
	// TODO: Next deployment replace with current url
	// public static delegateRequestNew: string = 'account/delegationrequest';
	public static getResources: string = 'contentApi/contentManagement/getLoginResources';
	public static setLanguageUrl: string = AppEndpoints.self + 'language/setLanguage/';

	/****** Unlock Account  *****/
	public static fetchEmail = 'account/FetchUnlockEmail';
	public static getPersonAccountUnlockOptions = 'account/GetPersonAccountUnlockOptions';
	public static sendUnlockEmail = 'account/SendUnlockEmail';
	public static verifyUnlockCode = 'account/VerifyCode';
	public static identifyUser = 'account/IdentifyUser';
	public static verifyUserIdentification = 'account/VerifyUserIdentification';

	/****** Initialize Password  *****/
	public static initializePassword = 'account/InitializePassword';
	public static sendInitPass = 'account/SendSmsOtp4PublicAccessInitPass';

	/****** Change Password  *****/
	public static sendChangePass = 'account/SendSmsOtp4PublicAccessChangePass';
	public static changePassword = 'account/ChangePassword';

	/****** Link User  *****/
	public static readonly linkUserStatus: string = 'account/links/userStatus';
	public static readonly initiateUserLink: string = 'account/links/initiate';
	public static readonly verifyInitiatorCode: string = 'account/links/initiator/verifyCode';
	public static readonly verifyTargetOtp: string = 'account/links/target/verifyCode';
	public static readonly completeUserLink: string = 'account/links/complete';

	public static readonly initiateUserSwitch: string = 'account/links/switch/initiate';
	public static readonly completeUserSwitch: string = 'account/links/switch/complete';

	public static readonly initiateLineRenewal: string = 'account/links/renew/initiate';

	public static readonly requestOtp: string = 'account/requestOtp';

	/****** Two Factor Authentication  *****/
	public static readonly twofaLogin: string = 'account/twofa/login';
	public static readonly twofaResendOtp: string = 'account/twofa/resendOtp';

	/****** FAQs  *****/
	public static readonly faqSections: string = 'contentApi/contentManagement/getLoginFaqSections';

	/****** Block user  *****/
	public static readonly blockUser: string = 'securityApi/security/publicBlockUser';

	/****** Impersonation login  *****/
	public static readonly impersonationUserStatus: string = 'account/impersonation/userStatus';
	public static readonly impersonationLogin: string = 'account/impersonation/login';

	/****** Existing Onboarding Customer  *****/
	public static readonly cardLogin: string = AppEndpoints.self + 'cardLogin/login';
	public static readonly cardInitUser: string = AppEndpoints.self + 'cardLogin/initUser';

	public static readonly sendIbankTerms: string =
		AppEndpoints.onboardingApiPrefix + 'customer/sendIbankTerms';
	public static readonly createApplication: string =
		AppEndpoints.onboardingApiPrefix + 'customer/createApplication';
	public static readonly getRegisteredMobileNumbers: string =
		AppEndpoints.onboardingApiPrefix + 'customer/getRegisteredMobileNumbers';
	public static readonly acceptIbankTerms: string =
		AppEndpoints.onboardingApiPrefix + 'customer/acceptIbankTerms';
	public static readonly resetCredentials: string =
		AppEndpoints.onboardingApiPrefix + 'customer/resetCredentials';
	public static readonly sendCode: string =
		AppEndpoints.onboardingApiPrefix + 'verification/sendCode';
	public static readonly verifyCode: string =
		AppEndpoints.onboardingApiPrefix + 'verification/verifyCode';
	public static readonly checkUsernameAvailability: string =
		AppEndpoints.onboardingApiPrefix + 'info/checkUsernameAvailability';

	/*
	 *
	 * TODO(A)
	 * Review after QA:
	 * public static readonly getApplication: string ='customer/getApplication';
	 * public static readonly saveApplicationData: string ='customer/saveApplicationData';
	 *
	 */
}
